import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axiosPublic from '../../utils/axios_public';
import { useTranslation } from 'react-i18next';

function ActivateAccount() {
  const {uidb64, token } = useParams(); // Destructure params for clarity
  const [activationStatus, setActivationStatus] = useState(null); // State for activation response
  const { t } = useTranslation();

    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);


  const fetchData = async () => {
    try {
      const response = await axiosPublic.post(
        `user/activate/account/${uidb64}/${token}/`
      );
      if (response.status >= 200 && response.status < 300) {
        setActivationStatus('success');
    } else {
        setActivationStatus('error');
    }
    
    } catch (error) {
      const msg = error.response?.data?.message || t("accountActivation.message.error");
      console.error('Error activating account:', error);
      setActivationStatus('error');
    }
  };

  useEffect(() => {
    fetchData();
  }, []); 

  return (
    <div className="activate-account-container">
      <div className="form-inner-container-2">
      {/* Email input */}
        <h1>{t("accountActivation.header")}</h1>
        {activationStatus === 'success' && (
          <p>{t("accountActivation.message.success")}</p>
        )}
        {activationStatus === 'error' ? (
          <p>{t("accountActivation.message.error")}</p>
          ) : (
            <div className="">
              <p className='font'>
              {t("accountActivation.description.login")} <Link className="sign-up-link" to="/login">Login</Link>
              </p>
            </div>
          )}                                                                                                  
      </div>
    </div>
  );
}

export default ActivateAccount;